import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  logout,
  setClouderType,
  setIsAuthorized,
  setIsBlocked,
  setIdUserStatus,
  setUsername,
} from '../features/auth/utils/loginSlice';
import { removeToken } from '../utils/token';
import { setIntercomUsername } from '../utils/intercom';
import { useVerifyToken } from '../features/auth/services';
import { useSyncActiveRouteToStore } from '../features/routes/enabled/hooks';

export default function useVerifyAuthorization() {
  const dispatch = useDispatch();
  const { isAuthorized, username: storedUsername } = useSelector(
    (store) => store.auth
  );

  const { isSuccess, isError, data, isPending, isFetching, fetchStatus } =
    useVerifyToken();
  const userType = data?.data?.type;
  const userUsername = data?.data?.username;
  const userIsBlocked = data?.data?.is_blocked;
  const userIdStatus = data?.data?.id_user_status;
  const userClouderType = data?.data?.clouderType;
  const isVerifiedClouder = isSuccess && userType === 'clouder';

  useSyncActiveRouteToStore();

  useEffect(() => {
    if (!isSuccess || userType !== 'clouder') {
      return;
    }

    const username = userUsername ?? storedUsername;
    if (username) {
      dispatch(setUsername(username));
      setIntercomUsername({ username });
    }

    if (userClouderType) {
      dispatch(setClouderType(userClouderType));
      localStorage.setItem('clouderType', userClouderType);
    }

    dispatch(setIsBlocked(Boolean(userIsBlocked)));
    dispatch(setIdUserStatus(userIdStatus ?? null));
    dispatch(setIsAuthorized(true));
  }, [
    isSuccess,
    userType,
    userUsername,
    userIsBlocked,
    userIdStatus,
    userClouderType,
    storedUsername,
    dispatch,
  ]);

  useEffect(() => {
    if (!isError) {
      return;
    }

    removeToken();
    localStorage.removeItem('clouderType');
    dispatch(logout());
  }, [isError, dispatch]);

  return {
    isVerifying: (isPending && fetchStatus !== 'idle') || isFetching,
    isAuthorized: Boolean(data?.auth) || isVerifiedClouder || isAuthorized,
  };
}
